const _SSPA_APP_ENV = (() => {
  try {
    return SSPA_APP_ENV
  } catch (error) {
    return 'dev'
  }
})()
/**
 * Contém variáveis de ambiente para mais fácil utilização
 */
export const Environment = {
  /**
   * Configura a mensagem que será exibida dentro dos campos de pesquisa
   */
  INPUT_DE_BUSCA: 'Pesquisar...',
  /**
   * Configura o limite de registros a serem exibidos nas listagens
   */
  LIMITE_DE_LINHAS: 7,
  /**
   * Configura a mensagem que será exibida quando uma listagem estiver vazia
   */
  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

  /**
   * Indica modo de `prod` no azure.
   */
  IS_PRODUCTION: _SSPA_APP_ENV === 'prod',
  /**
   * Indica modo de `dev` no azure.
   */
  IS_DEV: _SSPA_APP_ENV === 'dev',
  /**
   * Indica modo de `development` na máquina local.
   */
  IS_DEVELOPMENT: _SSPA_APP_ENV === 'development',
  /**
   * Indica modo de `hml` no azure.
   */
  IS_HOMOLOG: _SSPA_APP_ENV === 'hml',

  API_GATEWAY: SSPA_APP_ENV === 'prod'
    ? 'https://api.gvdasa.com.br'
    : SSPA_APP_ENV === 'hml'
      ? 'https://api-hml.gvdasa.com.br'
      : SSPA_APP_ENV === 'dev'
        ? 'https://api-dev.gvdasa.com.br'
        : 'https://api-dev.gvdasa.com.br',

  /**
   * Informa a url para a API
   */
  URL_API: _SSPA_APP_ENV === 'prod'
    ? 'https://api.gvdasa.com.br/'
    : _SSPA_APP_ENV === 'hml'
      ? 'https://api-hml.gvdasa.com.br/'
      : _SSPA_APP_ENV === 'dev'
        ? 'https://api-dev.gvdasa.com.br/'
        : 'https://api-dev.gvdasa.com.br/',

  /** Retorna true ou false se deve usar o origin debug nas requests */

  IS_USING_ORIGIN_DEBUG: _SSPA_APP_ENV === 'development' || (window.location.href.includes('localhost') && _SSPA_APP_ENV === 'dev'),

  /**
   * Informada quando está na máquina local, para permitir interação com o gateway.
   */

  URL_ORIGIN_DEBUG: _SSPA_APP_ENV === 'prod' || _SSPA_APP_ENV === 'hml' || _SSPA_APP_ENV === 'dev' ? '' : 'https://servicos-base-dev.hub.gvdasa.com.br',

  APP_INSIGHTS_CONNECTION_STRING: process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_ENV === 'hml' || process.env.REACT_APP_ENV === 'dev'
    ? process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING
    : ''
};
